"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, use, useState, useCallback, type ReactNode } from "react";
import { Toast, type Toast as ToastType } from "./Toast";
interface ToastContextValue {
  showToast: (toast: Omit<ToastType, "id">) => void;
  dismissToast: (id: string) => void;
}
const ToastContext = createContext<ToastContextValue | undefined>(undefined);
export function useToast() {
  const context = use(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within ToastProvider");
  }
  return context;
}
export function ToastProvider(t0) {
  const $ = _c(12);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [toasts, setToasts] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = toast => {
      const id = Math.random().toString(36).substring(2, 9);
      setToasts(prev => [...prev, {
        ...toast,
        id
      }]);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const showToast = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = id_0 => {
      setToasts(prev_0 => prev_0.filter(t => t.id !== id_0));
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const dismissToast = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      showToast,
      dismissToast
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== toasts) {
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = toast_0 => <Toast key={toast_0.id} toast={toast_0} onDismiss={dismissToast} />;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    t5 = toasts.map(t6);
    $[4] = toasts;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="fixed right-4 bottom-4 z-[110] flex flex-col gap-2" aria-live="polite" aria-atomic="false">{t5}</div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== children || $[10] !== t6) {
    t7 = <ToastContext.Provider value={t4}>{children}{t6}</ToastContext.Provider>;
    $[9] = children;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}